import {
  PUT_DEVICETYPES_CATALOG,
  PUT_DEVICETYPES_CATALOG_SUCCESS,
  PUT_DEVICETYPES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putDeviceTypesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_DEVICETYPES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_DEVICETYPES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_DEVICETYPES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
